// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright (c) 2026 Smart Touch Infotech Private Limited. All rights reserved. */
/* SAM (Smart Analyst for Markets) — Proprietary Software */

/* uEquity Portfolio Terminal */
.terminal {
  height: 100%;
  background: var(--bg);
  color: var(--text);
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  overflow: hidden;
  max-width: 100%;
}

/* Header */
.terminal-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  border-bottom: 1px solid var(--border);
  background: var(--sidebar);
  overflow: visible;
  max-width: 100%;
  gap: 8px;
}

.terminal-title h1 {
  font-size: 22px;
  font-weight: 700;
  color: var(--accent);
  margin: 0;
}

.terminal-subtitle {
  font-size: 12px;
  color: var(--text-dim);
  margin-left: 8px;
}

.terminal-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}

.session-badge {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.session-open { background: rgba(34,197,94,0.15); color: #22c55e; }
.session-pre { background: rgba(59,130,246,0.15); color: #3b82f6; }
.session-ah { background: rgba(168,85,247,0.15); color: #a855f7; }
.session-closed { background: rgba(100,116,139,0.15); color: #64748b; }

/* Live Feed Status Badge */
.feed-badge {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.feed-live {
  background: rgba(239,68,68,0.2);
  color: #ef4444;
  animation: feed-pulse 2s ease-in-out infinite;
}

.feed-connecting {
  background: rgba(234,179,8,0.15);
  color: #eab308;
}

.feed-error {
  background: rgba(100,116,139,0.15);
  color: #64748b;
}

@keyframes feed-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

.ext-toggle {
  background: var(--card);
  border: 1px solid var(--border);
  color: var(--text-dim);
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.ext-toggle.active {
  border-color: #a855f7;
  color: #a855f7;
  background: rgba(168,85,247,0.1);
}

.add-btn {
  background: var(--accent);
  border: none;
  color: white;
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}
.add-btn:hover { opacity: 0.85; }

.export-btn {
  background: none;
  border: 1px solid var(--accent);
  color: var(--accent);
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.5px;
  transition: all 0.2s;
}
.export-btn:hover { background: var(--accent); color: white; }

.logout-btn {
  background: none;
  border: 1px solid var(--red);
  color: var(--red);
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.logout-btn:hover {
  background: var(--red);
  color: white;
}

/* ─── Theme Toggle ───────────────────────────────────────────────── */
.theme-toggle {
  background: var(--card);
  border: 1px solid var(--border);
  color: var(--text);
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  padding: 0;
}

.theme-toggle:hover {
  border-color: var(--accent);
}

/* ─── Search Bar ─────────────────────────────────────────────────── */
.search-bar-wrap {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0;
  flex-shrink: 0;
}

.search-bar {
  background: var(--card);
  border: 1px solid var(--border);
  color: var(--text);
  padding: 6px 10px;
  border-radius: 6px 0 0 6px;
  font-size: 12px;
  outline: none;
  width: 180px;
  transition: border-color 0.2s;
}

.search-bar:focus {
  width: 220px;
  border-color: var(--accent);
}

.search-bar::placeholder {
  color: var(--text-dim);
}

.search-btn {
  background: var(--accent);
  border: none;
  color: white;
  padding: 6px 10px;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
  font-size: 12px;
  height: 100%;
}

.search-btn:hover {
  opacity: 0.85;
}

.search-popup {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 12px 16px;
  z-index: 1000;
  min-width: 220px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.3);
}

.search-popup-symbol {
  font-weight: 700;
  color: var(--accent);
  font-size: 16px;
  margin-bottom: 4px;
}

.search-popup-price {
  font-size: 20px;
  font-weight: 700;
  color: var(--text);
}

.search-popup-change {
  font-size: 13px;
  font-weight: 600;
  margin-top: 2px;
}

.search-popup-error {
  color: var(--red);
  font-size: 12px;
}

/* ─── Watchlist Panel ────────────────────────────────────────────── */
.watchlist-section {
  border-bottom: 1px solid var(--border);
  background: var(--sidebar);
}

.watchlist-toggle {
  background: none;
  border: none;
  color: var(--text-dim);
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  padding: 6px 24px;
  width: 100%;
  text-align: left;
  letter-spacing: 0.5px;
  transition: color 0.2s;
}

.watchlist-toggle:hover {
  color: var(--text);
}

.watchlist-panel {
  padding: 0 24px 10px;
  max-height: 200px;
  overflow-y: auto;
}

.watchlist-add {
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
}

.watchlist-add input {
  flex: 1 1;
  background: var(--card);
  border: 1px solid var(--border);
  color: var(--text);
  padding: 5px 8px;
  border-radius: 4px;
  font-size: 11px;
  outline: none;
}

.watchlist-add input:focus {
  border-color: var(--accent);
}

.watchlist-add input::placeholder {
  color: var(--text-dim);
}

.watchlist-add button {
  background: var(--accent);
  border: none;
  color: white;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
}

.watchlist-add button:disabled {
  opacity: 0.4;
}

.watchlist-empty {
  color: var(--text-dim);
  font-size: 11px;
  text-align: center;
  padding: 8px 0;
}

.watchlist-items {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.watchlist-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 6px;
  font-size: 11px;
}

.watchlist-sym {
  font-weight: 700;
  color: var(--accent);
}

.watchlist-price {
  color: var(--text);
}

.watchlist-chg {
  font-weight: 600;
}

.watchlist-remove {
  background: none;
  border: none;
  color: var(--text-dim);
  cursor: pointer;
  font-size: 14px;
  padding: 0 2px;
  line-height: 1;
}

.watchlist-remove:hover {
  color: var(--red);
}

/* ─── P&L Mini Chart ─────────────────────────────────────────────── */
.summary-chart {
  min-width: 140px;
  flex: 1 1;
}

.pnl-chart-wrap {
  height: 80px;
  margin-top: 2px;
}

/* Summary bar */
.summary-bar {
  display: flex;
  gap: 32px;
  padding: 14px 24px;
  background: var(--sidebar);
  border-bottom: 1px solid var(--border);
  align-items: flex-start;
  overflow: hidden;
  max-width: 100%;
  flex-wrap: wrap;
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.summary-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--text-dim);
}

.summary-value {
  font-size: 16px;
  font-weight: 700;
}

/* Table */
.table-wrap {
  flex: 1 1;
  overflow-x: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0;
  max-width: 100%;
  width: 100%;
}

.equity-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  white-space: nowrap;
}

.equity-table th,
.equity-table td {
  padding: 8px 12px;
  text-align: right;
  border-bottom: 1px solid var(--border);
}

.equity-table th:first-child,
.equity-table td:first-child {
  text-align: left;
}

/* Group headers */
.group-header th {
  padding: 6px 12px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-align: center;
  border-bottom: 2px solid var(--border);
}

.group-position { color: #94a3b8; background: rgba(148,163,184,0.05); }
.group-quote { color: var(--accent); background: rgba(59,130,246,0.05); }
.group-day { color: var(--orange); background: rgba(245,158,11,0.05); }
.group-extended { color: #a855f7; background: rgba(168,85,247,0.05); }
.group-pl { color: var(--green); background: rgba(34,197,94,0.05); }
.group-action { width: 30px; }

/* Column headers */
.col-header th {
  font-size: 10px;
  font-weight: 600;
  color: var(--text-dim);
  letter-spacing: 0.3px;
  background: var(--table-header-bg);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 1;
}

/* Data rows */
.equity-table tbody tr {
  transition: background 0.15s;
}

.equity-table tbody tr:hover {
  background: var(--table-hover);
}

.symbol-cell {
  text-align: left !important;
}

.symbol-name {
  font-weight: 700;
  color: var(--accent);
  font-size: 14px;
}

.company-name {
  font-size: 10px;
  color: var(--text-dim);
  margin-top: 1px;
}

/* Bid/Ask coloring */
.bid-col { color: #f97316 !important; }
.ask-col { color: #22c55e !important; }
.bid-cell { color: #f97316; }
.ask-cell { color: #22c55e; }

/* Mid cell with spread indicator */
.mid-cell {
  position: relative;
}

.spread-bar-wrap {
  height: 3px;
  background: rgba(255,255,255,0.05);
  border-radius: 2px;
  margin-top: 3px;
  overflow: hidden;
}

[data-theme="light"] .spread-bar-wrap {
  background: rgba(0,0,0,0.08);
}

.spread-bar {
  height: 100%;
  background: linear-gradient(90deg, #f97316, #22c55e);
  border-radius: 2px;
  transition: width 0.3s;
}

/* Price flash */
.last-cell {
  transition: background 0.1s;
}

.flash-green {
  background: rgba(34, 197, 94, 0.25) !important;
}

.flash-red {
  background: rgba(239, 68, 68, 0.25) !important;
}

/* Colors */
.green { color: var(--green); }
.red { color: var(--red); }
.bold { font-weight: 700; }

/* Totals row */
.totals-row {
  background: var(--sidebar) !important;
  border-top: 2px solid var(--border);
}

.totals-label {
  text-align: left !important;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-dim);
  letter-spacing: 0.3px;
}

.empty-msg {
  text-align: center !important;
  color: var(--text-dim);
  padding: 60px 0 !important;
  font-size: 14px;
}

/* Remove button */
.remove-btn {
  background: none;
  border: 1px solid transparent;
  color: var(--text-dim);
  font-size: 14px;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  transition: all 0.2s;
}
.remove-btn:hover {
  color: var(--red);
  border-color: var(--red);
}

/* Legend */
.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
  padding: 10px 24px;
  border-top: 1px solid var(--border);
  background: var(--table-header-bg);
  font-size: 11px;
  color: var(--text-dim);
  overflow: hidden;
}

.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  margin-right: 4px;
}

.bid-dot { background: #f97316; }
.ask-dot { background: #22c55e; }
.last-dot { background: var(--accent); }

/* Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal {
  background: var(--modal-bg);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 24px;
  width: 340px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.modal h3 {
  font-size: 16px;
  color: var(--text);
  margin: 0;
}

.modal input {
  background: var(--modal-input-bg);
  border: 1px solid var(--border);
  color: var(--text);
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
}

.modal input:focus {
  border-color: var(--accent);
}

.modal-actions {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}

.modal-cancel {
  flex: 1 1;
  background: var(--border);
  border: none;
  color: var(--text);
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
}

.modal-add {
  flex: 1 1;
  background: var(--accent);
  border: none;
  color: white;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
}

.modal-add:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Footer */
.terminal-footer {
  padding: 6px 24px;
  font-size: 10px;
  color: var(--text-dim);
  text-align: center;
  border-top: 1px solid var(--border);
}

/* Modal labels */
.modal label {
  font-size: 11px;
  color: var(--text-dim);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-preview {
  font-size: 13px;
  color: var(--text-dim);
  text-align: center;
  padding: 4px 0;
}

.left { text-align: left !important; }

/* Show only on mobile */
.show-mobile-only { display: none; }

@media (max-width: 768px) {
  .show-mobile-only { display: table-cell; }
}

.table-wrap::-webkit-scrollbar { width: 6px; height: 6px; }
.table-wrap::-webkit-scrollbar-track { background: transparent; }
.table-wrap::-webkit-scrollbar-thumb { background: var(--border); border-radius: 3px; }

/* ─── Mobile: Hide non-essential table columns ──────────────────── */
@media (max-width: 768px) {
  .terminal {
    overflow-x: hidden;
    max-width: 100vw;
    width: 100%;
  }

  .terminal-header {
    padding: 8px 10px;
    flex-direction: column;
    gap: 6px;
    align-items: stretch;
    overflow: visible;
  }

  .terminal-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .terminal-title h1 {
    font-size: 16px;
  }

  .terminal-subtitle {
    display: none;
  }

  .terminal-controls {
    gap: 5px;
    flex-wrap: wrap;
    overflow: visible;
  }

  /* Hide non-essential controls */
  .terminal-controls .ext-toggle {
    display: none;
  }

  .terminal-controls .feed-badge {
    font-size: 8px;
    padding: 2px 6px;
  }

  .terminal-controls .session-badge {
    font-size: 8px;
    padding: 2px 6px;
  }

  .add-btn {
    font-size: 10px;
    padding: 4px 8px;
  }

  .logout-btn {
    font-size: 10px;
    padding: 4px 8px;
  }

  .theme-toggle {
    width: 26px;
    height: 26px;
    font-size: 13px;
  }

  .search-bar-wrap {
    flex: 1 1;
    min-width: 0;
  }

  .search-bar {
    width: 100%;
    min-width: 0;
    font-size: 11px;
    padding: 4px 6px;
  }

  .search-btn {
    padding: 4px 6px;
    font-size: 11px;
  }

  /* Summary bar */
  .summary-bar {
    padding: 8px 10px;
    gap: 8px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .summary-item.summary-chart {
    grid-column: 1 / -1;
  }

  .summary-value {
    font-size: 14px;
  }

  .summary-label {
    font-size: 9px;
  }

  .pnl-chart-wrap {
    height: 60px;
  }

  /* Table — hide columns that aren't essential on mobile */
  /* Hide: QTY, BUY PRICE, COST BASIS, BID, ASK, MID, CHG\$ */
  .equity-table .hide-mobile {
    display: none;
  }

  .table-wrap {
    max-width: 100vw;
    width: 100%;
  }

  .equity-table {
    font-size: 11px;
    min-width: 0;
    width: 100%;
    table-layout: auto;
  }

  .equity-table th,
  .equity-table td {
    padding: 6px 4px;
    font-size: 10px;
  }

  .symbol-name {
    font-size: 11px;
  }

  .company-name {
    display: none;
  }

  .spread-bar-wrap {
    display: none;
  }

  /* Group headers — simplify */
  .group-header th {
    font-size: 8px;
    padding: 4px 4px;
    letter-spacing: 0.3px;
  }

  .col-header th {
    font-size: 8px;
    padding: 4px 4px;
  }

  /* Legend */
  .legend {
    padding: 6px 10px;
    gap: 4px 10px;
    font-size: 8px;
  }

  /* Watchlist */
  .watchlist-panel {
    padding: 0 10px 8px;
    max-height: 100px;
  }

  .watchlist-toggle {
    padding: 5px 10px;
  }

  .watchlist-item {
    font-size: 10px;
    padding: 3px 6px;
  }

  /* Search popup */
  .search-popup {
    right: 0;
    left: auto;
    max-width: 180px;
  }

  /* Modal */
  .modal {
    width: 90vw;
    max-width: 90vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Portfolio.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF,2DAA2D;;AAE3D,+BAA+B;AAC/B;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sEAAsE;EACtE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,gBAAgB,gCAAgC,EAAE,cAAc,EAAE;AAClE,eAAe,iCAAiC,EAAE,cAAc,EAAE;AAClE,cAAc,iCAAiC,EAAE,cAAc,EAAE;AACjE,kBAAkB,kCAAkC,EAAE,cAAc,EAAE;;AAEtE,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;AACA,iBAAiB,aAAa,EAAE;;AAEhC;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;AACA,oBAAoB,yBAAyB,EAAE,YAAY,EAAE;;AAE7D;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA,uEAAuE;AACvE;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,uEAAuE;AACvE;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uEAAuE;AACvE;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,kBAAkB,cAAc,EAAE,kCAAkC,EAAE;AACtE,eAAe,oBAAoB,EAAE,iCAAiC,EAAE;AACxE,aAAa,oBAAoB,EAAE,iCAAiC,EAAE;AACtE,kBAAkB,cAAc,EAAE,iCAAiC,EAAE;AACrE,YAAY,mBAAmB,EAAE,gCAAgC,EAAE;AACnE,gBAAgB,WAAW,EAAE;;AAE7B,mBAAmB;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,kCAAkC;EAClC,sCAAsC;EACtC,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA,qBAAqB;AACrB,WAAW,yBAAyB,EAAE;AACtC,WAAW,yBAAyB,EAAE;AACtC,YAAY,cAAc,EAAE;AAC5B,YAAY,cAAc,EAAE;;AAE5B,mCAAmC;AACnC;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA,WAAW;AACX,SAAS,mBAAmB,EAAE;AAC9B,OAAO,iBAAiB,EAAE;AAC1B,QAAQ,gBAAgB,EAAE;;AAE1B,eAAe;AACf;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,WAAW,mBAAmB,EAAE;AAChC,WAAW,mBAAmB,EAAE;AAChC,YAAY,yBAAyB,EAAE;;AAEvC,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,QAAQ,2BAA2B,EAAE;;AAErC,wBAAwB;AACxB,oBAAoB,aAAa,EAAE;;AAEnC;EACE,oBAAoB,mBAAmB,EAAE;AAC3C;;AAEA,iCAAiC,UAAU,EAAE,WAAW,EAAE;AAC1D,uCAAuC,uBAAuB,EAAE;AAChE,uCAAuC,yBAAyB,EAAE,kBAAkB,EAAE;;AAEtF,sEAAsE;AACtE;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,iBAAiB;EACnB;;EAEA,gCAAgC;EAChC;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,QAAQ;IACR,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA,yDAAyD;EACzD,0DAA0D;EAC1D;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,6BAA6B;EAC7B;IACE,cAAc;IACd,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;;EAEA,cAAc;EACd;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,QAAQ;IACR,UAAU;IACV,gBAAgB;EAClB;;EAEA,UAAU;EACV;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* Copyright (c) 2026 Smart Touch Infotech Private Limited. All rights reserved. */\n/* SAM (Smart Analyst for Markets) — Proprietary Software */\n\n/* uEquity Portfolio Terminal */\n.terminal {\n  height: 100%;\n  background: var(--bg);\n  color: var(--text);\n  display: flex;\n  flex-direction: column;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  overflow: hidden;\n  max-width: 100%;\n}\n\n/* Header */\n.terminal-header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px;\n  border-bottom: 1px solid var(--border);\n  background: var(--sidebar);\n  overflow: visible;\n  max-width: 100%;\n  gap: 8px;\n}\n\n.terminal-title h1 {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--accent);\n  margin: 0;\n}\n\n.terminal-subtitle {\n  font-size: 12px;\n  color: var(--text-dim);\n  margin-left: 8px;\n}\n\n.terminal-controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.session-badge {\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.session-open { background: rgba(34,197,94,0.15); color: #22c55e; }\n.session-pre { background: rgba(59,130,246,0.15); color: #3b82f6; }\n.session-ah { background: rgba(168,85,247,0.15); color: #a855f7; }\n.session-closed { background: rgba(100,116,139,0.15); color: #64748b; }\n\n/* Live Feed Status Badge */\n.feed-badge {\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n}\n\n.feed-live {\n  background: rgba(239,68,68,0.2);\n  color: #ef4444;\n  animation: feed-pulse 2s ease-in-out infinite;\n}\n\n.feed-connecting {\n  background: rgba(234,179,8,0.15);\n  color: #eab308;\n}\n\n.feed-error {\n  background: rgba(100,116,139,0.15);\n  color: #64748b;\n}\n\n@keyframes feed-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.6; }\n}\n\n.ext-toggle {\n  background: var(--card);\n  border: 1px solid var(--border);\n  color: var(--text-dim);\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.ext-toggle.active {\n  border-color: #a855f7;\n  color: #a855f7;\n  background: rgba(168,85,247,0.1);\n}\n\n.add-btn {\n  background: var(--accent);\n  border: none;\n  color: white;\n  padding: 6px 16px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n.add-btn:hover { opacity: 0.85; }\n\n.export-btn {\n  background: none;\n  border: 1px solid var(--accent);\n  color: var(--accent);\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  letter-spacing: 0.5px;\n  transition: all 0.2s;\n}\n.export-btn:hover { background: var(--accent); color: white; }\n\n.logout-btn {\n  background: none;\n  border: 1px solid var(--red);\n  color: var(--red);\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.logout-btn:hover {\n  background: var(--red);\n  color: white;\n}\n\n/* ─── Theme Toggle ───────────────────────────────────────────────── */\n.theme-toggle {\n  background: var(--card);\n  border: 1px solid var(--border);\n  color: var(--text);\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  padding: 0;\n}\n\n.theme-toggle:hover {\n  border-color: var(--accent);\n}\n\n/* ─── Search Bar ─────────────────────────────────────────────────── */\n.search-bar-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0;\n  flex-shrink: 0;\n}\n\n.search-bar {\n  background: var(--card);\n  border: 1px solid var(--border);\n  color: var(--text);\n  padding: 6px 10px;\n  border-radius: 6px 0 0 6px;\n  font-size: 12px;\n  outline: none;\n  width: 180px;\n  transition: border-color 0.2s;\n}\n\n.search-bar:focus {\n  width: 220px;\n  border-color: var(--accent);\n}\n\n.search-bar::placeholder {\n  color: var(--text-dim);\n}\n\n.search-btn {\n  background: var(--accent);\n  border: none;\n  color: white;\n  padding: 6px 10px;\n  border-radius: 0 6px 6px 0;\n  cursor: pointer;\n  font-size: 12px;\n  height: 100%;\n}\n\n.search-btn:hover {\n  opacity: 0.85;\n}\n\n.search-popup {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 4px;\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 12px 16px;\n  z-index: 1000;\n  min-width: 220px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.3);\n}\n\n.search-popup-symbol {\n  font-weight: 700;\n  color: var(--accent);\n  font-size: 16px;\n  margin-bottom: 4px;\n}\n\n.search-popup-price {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.search-popup-change {\n  font-size: 13px;\n  font-weight: 600;\n  margin-top: 2px;\n}\n\n.search-popup-error {\n  color: var(--red);\n  font-size: 12px;\n}\n\n/* ─── Watchlist Panel ────────────────────────────────────────────── */\n.watchlist-section {\n  border-bottom: 1px solid var(--border);\n  background: var(--sidebar);\n}\n\n.watchlist-toggle {\n  background: none;\n  border: none;\n  color: var(--text-dim);\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 6px 24px;\n  width: 100%;\n  text-align: left;\n  letter-spacing: 0.5px;\n  transition: color 0.2s;\n}\n\n.watchlist-toggle:hover {\n  color: var(--text);\n}\n\n.watchlist-panel {\n  padding: 0 24px 10px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.watchlist-add {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.watchlist-add input {\n  flex: 1;\n  background: var(--card);\n  border: 1px solid var(--border);\n  color: var(--text);\n  padding: 5px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  outline: none;\n}\n\n.watchlist-add input:focus {\n  border-color: var(--accent);\n}\n\n.watchlist-add input::placeholder {\n  color: var(--text-dim);\n}\n\n.watchlist-add button {\n  background: var(--accent);\n  border: none;\n  color: white;\n  width: 26px;\n  height: 26px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.watchlist-add button:disabled {\n  opacity: 0.4;\n}\n\n.watchlist-empty {\n  color: var(--text-dim);\n  font-size: 11px;\n  text-align: center;\n  padding: 8px 0;\n}\n\n.watchlist-items {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.watchlist-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  font-size: 11px;\n}\n\n.watchlist-sym {\n  font-weight: 700;\n  color: var(--accent);\n}\n\n.watchlist-price {\n  color: var(--text);\n}\n\n.watchlist-chg {\n  font-weight: 600;\n}\n\n.watchlist-remove {\n  background: none;\n  border: none;\n  color: var(--text-dim);\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0 2px;\n  line-height: 1;\n}\n\n.watchlist-remove:hover {\n  color: var(--red);\n}\n\n/* ─── P&L Mini Chart ─────────────────────────────────────────────── */\n.summary-chart {\n  min-width: 140px;\n  flex: 1;\n}\n\n.pnl-chart-wrap {\n  height: 80px;\n  margin-top: 2px;\n}\n\n/* Summary bar */\n.summary-bar {\n  display: flex;\n  gap: 32px;\n  padding: 14px 24px;\n  background: var(--sidebar);\n  border-bottom: 1px solid var(--border);\n  align-items: flex-start;\n  overflow: hidden;\n  max-width: 100%;\n  flex-wrap: wrap;\n}\n\n.summary-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.summary-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: var(--text-dim);\n}\n\n.summary-value {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n/* Table */\n.table-wrap {\n  flex: 1;\n  overflow-x: auto;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 0;\n  max-width: 100%;\n  width: 100%;\n}\n\n.equity-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.equity-table th,\n.equity-table td {\n  padding: 8px 12px;\n  text-align: right;\n  border-bottom: 1px solid var(--border);\n}\n\n.equity-table th:first-child,\n.equity-table td:first-child {\n  text-align: left;\n}\n\n/* Group headers */\n.group-header th {\n  padding: 6px 12px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  text-align: center;\n  border-bottom: 2px solid var(--border);\n}\n\n.group-position { color: #94a3b8; background: rgba(148,163,184,0.05); }\n.group-quote { color: var(--accent); background: rgba(59,130,246,0.05); }\n.group-day { color: var(--orange); background: rgba(245,158,11,0.05); }\n.group-extended { color: #a855f7; background: rgba(168,85,247,0.05); }\n.group-pl { color: var(--green); background: rgba(34,197,94,0.05); }\n.group-action { width: 30px; }\n\n/* Column headers */\n.col-header th {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--text-dim);\n  letter-spacing: 0.3px;\n  background: var(--table-header-bg);\n  border-bottom: 1px solid var(--border);\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n/* Data rows */\n.equity-table tbody tr {\n  transition: background 0.15s;\n}\n\n.equity-table tbody tr:hover {\n  background: var(--table-hover);\n}\n\n.symbol-cell {\n  text-align: left !important;\n}\n\n.symbol-name {\n  font-weight: 700;\n  color: var(--accent);\n  font-size: 14px;\n}\n\n.company-name {\n  font-size: 10px;\n  color: var(--text-dim);\n  margin-top: 1px;\n}\n\n/* Bid/Ask coloring */\n.bid-col { color: #f97316 !important; }\n.ask-col { color: #22c55e !important; }\n.bid-cell { color: #f97316; }\n.ask-cell { color: #22c55e; }\n\n/* Mid cell with spread indicator */\n.mid-cell {\n  position: relative;\n}\n\n.spread-bar-wrap {\n  height: 3px;\n  background: rgba(255,255,255,0.05);\n  border-radius: 2px;\n  margin-top: 3px;\n  overflow: hidden;\n}\n\n[data-theme=\"light\"] .spread-bar-wrap {\n  background: rgba(0,0,0,0.08);\n}\n\n.spread-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #f97316, #22c55e);\n  border-radius: 2px;\n  transition: width 0.3s;\n}\n\n/* Price flash */\n.last-cell {\n  transition: background 0.1s;\n}\n\n.flash-green {\n  background: rgba(34, 197, 94, 0.25) !important;\n}\n\n.flash-red {\n  background: rgba(239, 68, 68, 0.25) !important;\n}\n\n/* Colors */\n.green { color: var(--green); }\n.red { color: var(--red); }\n.bold { font-weight: 700; }\n\n/* Totals row */\n.totals-row {\n  background: var(--sidebar) !important;\n  border-top: 2px solid var(--border);\n}\n\n.totals-label {\n  text-align: left !important;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-dim);\n  letter-spacing: 0.3px;\n}\n\n.empty-msg {\n  text-align: center !important;\n  color: var(--text-dim);\n  padding: 60px 0 !important;\n  font-size: 14px;\n}\n\n/* Remove button */\n.remove-btn {\n  background: none;\n  border: 1px solid transparent;\n  color: var(--text-dim);\n  font-size: 14px;\n  cursor: pointer;\n  padding: 2px 6px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n.remove-btn:hover {\n  color: var(--red);\n  border-color: var(--red);\n}\n\n/* Legend */\n.legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 20px;\n  padding: 10px 24px;\n  border-top: 1px solid var(--border);\n  background: var(--table-header-bg);\n  font-size: 11px;\n  color: var(--text-dim);\n  overflow: hidden;\n}\n\n.dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  margin-right: 4px;\n}\n\n.bid-dot { background: #f97316; }\n.ask-dot { background: #22c55e; }\n.last-dot { background: var(--accent); }\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n}\n\n.modal {\n  background: var(--modal-bg);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 24px;\n  width: 340px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.modal h3 {\n  font-size: 16px;\n  color: var(--text);\n  margin: 0;\n}\n\n.modal input {\n  background: var(--modal-input-bg);\n  border: 1px solid var(--border);\n  color: var(--text);\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 14px;\n  outline: none;\n}\n\n.modal input:focus {\n  border-color: var(--accent);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.modal-cancel {\n  flex: 1;\n  background: var(--border);\n  border: none;\n  color: var(--text);\n  padding: 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.modal-add {\n  flex: 1;\n  background: var(--accent);\n  border: none;\n  color: white;\n  padding: 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.modal-add:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Footer */\n.terminal-footer {\n  padding: 6px 24px;\n  font-size: 10px;\n  color: var(--text-dim);\n  text-align: center;\n  border-top: 1px solid var(--border);\n}\n\n/* Modal labels */\n.modal label {\n  font-size: 11px;\n  color: var(--text-dim);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.modal-preview {\n  font-size: 13px;\n  color: var(--text-dim);\n  text-align: center;\n  padding: 4px 0;\n}\n\n.left { text-align: left !important; }\n\n/* Show only on mobile */\n.show-mobile-only { display: none; }\n\n@media (max-width: 768px) {\n  .show-mobile-only { display: table-cell; }\n}\n\n.table-wrap::-webkit-scrollbar { width: 6px; height: 6px; }\n.table-wrap::-webkit-scrollbar-track { background: transparent; }\n.table-wrap::-webkit-scrollbar-thumb { background: var(--border); border-radius: 3px; }\n\n/* ─── Mobile: Hide non-essential table columns ──────────────────── */\n@media (max-width: 768px) {\n  .terminal {\n    overflow-x: hidden;\n    max-width: 100vw;\n    width: 100%;\n  }\n\n  .terminal-header {\n    padding: 8px 10px;\n    flex-direction: column;\n    gap: 6px;\n    align-items: stretch;\n    overflow: visible;\n  }\n\n  .terminal-title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .terminal-title h1 {\n    font-size: 16px;\n  }\n\n  .terminal-subtitle {\n    display: none;\n  }\n\n  .terminal-controls {\n    gap: 5px;\n    flex-wrap: wrap;\n    overflow: visible;\n  }\n\n  /* Hide non-essential controls */\n  .terminal-controls .ext-toggle {\n    display: none;\n  }\n\n  .terminal-controls .feed-badge {\n    font-size: 8px;\n    padding: 2px 6px;\n  }\n\n  .terminal-controls .session-badge {\n    font-size: 8px;\n    padding: 2px 6px;\n  }\n\n  .add-btn {\n    font-size: 10px;\n    padding: 4px 8px;\n  }\n\n  .logout-btn {\n    font-size: 10px;\n    padding: 4px 8px;\n  }\n\n  .theme-toggle {\n    width: 26px;\n    height: 26px;\n    font-size: 13px;\n  }\n\n  .search-bar-wrap {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .search-bar {\n    width: 100%;\n    min-width: 0;\n    font-size: 11px;\n    padding: 4px 6px;\n  }\n\n  .search-btn {\n    padding: 4px 6px;\n    font-size: 11px;\n  }\n\n  /* Summary bar */\n  .summary-bar {\n    padding: 8px 10px;\n    gap: 8px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .summary-item.summary-chart {\n    grid-column: 1 / -1;\n  }\n\n  .summary-value {\n    font-size: 14px;\n  }\n\n  .summary-label {\n    font-size: 9px;\n  }\n\n  .pnl-chart-wrap {\n    height: 60px;\n  }\n\n  /* Table — hide columns that aren't essential on mobile */\n  /* Hide: QTY, BUY PRICE, COST BASIS, BID, ASK, MID, CHG$ */\n  .equity-table .hide-mobile {\n    display: none;\n  }\n\n  .table-wrap {\n    max-width: 100vw;\n    width: 100%;\n  }\n\n  .equity-table {\n    font-size: 11px;\n    min-width: 0;\n    width: 100%;\n    table-layout: auto;\n  }\n\n  .equity-table th,\n  .equity-table td {\n    padding: 6px 4px;\n    font-size: 10px;\n  }\n\n  .symbol-name {\n    font-size: 11px;\n  }\n\n  .company-name {\n    display: none;\n  }\n\n  .spread-bar-wrap {\n    display: none;\n  }\n\n  /* Group headers — simplify */\n  .group-header th {\n    font-size: 8px;\n    padding: 4px 4px;\n    letter-spacing: 0.3px;\n  }\n\n  .col-header th {\n    font-size: 8px;\n    padding: 4px 4px;\n  }\n\n  /* Legend */\n  .legend {\n    padding: 6px 10px;\n    gap: 4px 10px;\n    font-size: 8px;\n  }\n\n  /* Watchlist */\n  .watchlist-panel {\n    padding: 0 10px 8px;\n    max-height: 100px;\n  }\n\n  .watchlist-toggle {\n    padding: 5px 10px;\n  }\n\n  .watchlist-item {\n    font-size: 10px;\n    padding: 3px 6px;\n  }\n\n  /* Search popup */\n  .search-popup {\n    right: 0;\n    left: auto;\n    max-width: 180px;\n  }\n\n  /* Modal */\n  .modal {\n    width: 90vw;\n    max-width: 90vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
